// extracted by mini-css-extract-plugin
export default {"btn":"ButtonPrevNext_btn__iFA0B","content":"ButtonPrevNext_content__jRmoc","next":"ButtonPrevNext_next__Q9OcZ","prev":"ButtonPrevNext_prev__VGPtE"};